import React from 'react';
import Icon from '../../../components/AppIcon';
import Input from '../../../components/ui/Input';

const Core4Section = ({ core4Goals, onCore4Change }) => {
  const core4Areas = [
    {
      key: 'faith',
      label: 'Faith',
      icon: 'Heart',
      placeholder: 'Spiritual growth, prayer, meditation...',
      color: 'text-purple-600'
    },
    {
      key: 'family',
      label: 'Family',
      icon: 'Users',
      placeholder: 'Quality time, communication, support...',
      color: 'text-blue-600'
    },
    {
      key: 'finances',
      label: 'Finances',
      icon: 'DollarSign',
      placeholder: 'Budgeting, saving, investing...',
      color: 'text-green-600'
    },
    {
      key: 'fitness',
      label: 'Fitness',
      icon: 'Dumbbell',
      placeholder: 'Exercise, nutrition, wellness...',
      color: 'text-orange-600'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg shadow-gentle p-6 mb-6">
      {/* Section Header */}
      <div className="flex items-center space-x-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 bg-accent rounded-lg">
          <Icon name="Target" size={20} className="text-accent-foreground" />
        </div>
        <div>
          <h3 className="text-lg font-heading font-semibold text-foreground">
            CORE4 Daily Goals
          </h3>
          <p className="text-sm text-muted-foreground">
            Set your intentions for the four key areas
          </p>
        </div>
      </div>
      {/* CORE4 Goal Inputs */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {core4Areas?.map((area) => (
          <div key={area?.key} className="space-y-2">
            <div className="flex items-center space-x-2 mb-2">
              <Icon name={area?.icon} size={18} className={area?.color} />
              <label className="font-caption font-medium text-foreground">
                {area?.label}
              </label>
            </div>
            <Input
              type="text"
              value={core4Goals?.[area?.key] || ''}
              onChange={(e) => onCore4Change(area?.key, e?.target?.value)}
              placeholder={area?.placeholder}
              className="min-h-touch"
            />
          </div>
        ))}
      </div>
      {/* Helper Text */}
      <div className="mt-4 p-3 bg-muted/30 rounded-lg">
        <p className="text-xs text-muted-foreground">
          <Icon name="Lightbulb" size={14} className="inline mr-1" />
          Keep goals specific and actionable. These will carry forward to tomorrow unless you change them.
        </p>
      </div>
    </div>
  );
};

export default Core4Section;